<app-info-modal>
    <ng-container modal-header>
        <h3>{{ 'EAN.LABEL' | translate }}</h3>
    </ng-container>
    <smvd-ui-table [items]="data" [def]="tableDef"></smvd-ui-table>
</app-info-modal>
